import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdBotTrackingSettings = "/apps/:app_group_id/bot_tracking_settings";

export const appsAppGroupIdBotTrackingSettingsCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_group_id/bot_tracking_settings",
];
